<script lang="ts">
    import { kirbyFetch } from "../../../../api/kirby/api"
    import MedialibImage from "../../../widgets/MedialibImage.svelte"
    import VideoJs from "../VideoTextRow/VideoJs.svelte"
    import SlideText from "./SlideText.svelte"

    let {
        slide,
        type = "primary",
        number = 2,
        splitted = false,
        publication_date,
    }: {
        slide: Slide
        type?: "primary" | "secondary"
        number?: number
        splitted?: boolean
        publication_date?: string
    } = $props()
    let video: FileData = $state()
    if (slide.uses_video) {
        kirbyFetch<FileData>({
            query: `file('${slide.background_video[0]}')`,
        }).then((res) => {
            video = res
        })
    } else if (typeof slide.background_image === "string") {
        slide.background_image = [(slide.background_image as string).slice(3, -1)]
    }

    let active = $state(false)
</script>

<section
    class:splitted
    class="{type} default-slide number-{number}"
    class:activeS={active}
    role="region"
    onmouseenter={() => (active = true)}
    onmouseleave={() => (active = false)}
    ontouchstart={() => (active = true)}
    ontouchend={() => (active = false)}
>
    {#if slide.uses_video}
        {#if video}
            <div class="background-image">
                <VideoJs src={video.url} controls={false} autoplay loop muted preload="auto" />
            </div>
        {/if}
    {:else}
        <div class="background-image">
            <MedialibImage id={slide.background_image} />
        </div>
    {/if}
    <div class="overlay">
        <div class="inner-container">
            <SlideText {slide} {type} {splitted} {active} {publication_date} />
        </div>
    </div>
</section>

<style lang="less" global>
    @import "../../../../css/variables.less";
    section.default-slide {
        width: 100%;
        height: 100%;
        position: relative;
        .background-image {
            width: 100%;
            height: 100%;
            &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 10;
                background: radial-gradient(circle, transparent 0%, #1d1d1b 100%);
                transition: background 0.5s;
            }
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            & > div.video-js {
                height: 100% !important;
                max-height: 100% !important;
                padding-top: unset !important;
                .vjs-tech {
                    width: 100%;
                    height: 100%;
                    object-fit: cover; /* Schneidet das Video zu */
                    object-position: center; /* Zentriert das Video */
                }
            }
        }

        &.activeS {
            .background-image::before {
                background: radial-gradient(circle, transparent 0%, #1d1d1b 100%), rgba(0, 0, 0, 0.5);
            }
        }
        .overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 100;
            height: 100%;
            display: flex;
            justify-content: center;
            .inner-container {
                max-width: var(--extended-max-width);
                width: 100%;
                display: flex;
                justify-content: flex-start;
                align-items: flex-end;
                margin: calc(var(--default-padding) * 1.5) var(--default-padding);

                @media @max-mobile {
                    margin-bottom: 140px;
                }
            }
        }

        &.number-1 .overlay {
            .inner-container {
                margin: var(--default-padding);
            }
        }
        &.splitted {
            .overlay .inner-container {
                margin-bottom: 40px;
            }

            &.secondary .overlay .inner-container {
                margin-bottom: 100px;
            }

            @media @desktop_large {
                .overlay .inner-container {
                    margin-bottom: 60px;
                }
                &.secondary .overlay .inner-container {
                    margin-bottom: 100px;
                }
                &.number-1.secondary .overlay .inner-container {
                    margin-bottom: 80px;
                }
            }
            @media (min-width: 2000px) {
                .overlay .inner-container {
                    max-width: calc(var(--extended-max-width) * 2 / 3);
                    margin-bottom: 80px;
                }

                .overlay {
                    justify-content: flex-end;
                    .inner-container {
                        margin-left: 0px !important;
                        margin-right: calc(var(--default-padding) * 4 / 3);
                    }
                }
                &.secondary .overlay {
                    justify-content: flex-start;
                }
                &.secondary .overlay .inner-container {
                    margin-bottom: 100px;
                    padding-left: 2.4rem;
                    max-width: calc(var(--extended-max-width) * 1 / 3 - var(--default-padding) * 4 / 3);
                }
                &.number-1.secondary .overlay .inner-container {
                    margin-bottom: 50px;
                }
            }
        }
    }
</style>
